import React, { Component } from 'react';
import { FormField } from '../FormField';
import { AnvilSelect, } from '../AnvilSelect';
export class FormAnvilSelect extends Component {
    render() {
        return (React.createElement(FormField, Object.assign({ control: AnvilSelect, className: "a-Select--Form" }, this.props)));
    }
}
//# sourceMappingURL=FormAnvilSelect.js.map